import { myResourceTypeBindingsService } from 'v5/services/internal/ResourceTypeBindingsService/ResourceTypeBindingsService.connected';
import { createResourceTypeService } from './ResourceTypeService.impl';

export const myResourceTypeService = createResourceTypeService({
  resourceTypeBindingsService: myResourceTypeBindingsService
});
